import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureFlags } from '@app/core/feature-flags/feature-flags';
import { LaunchDarklyService } from '@app/core/feature-flags/launchdarkly.service';
import { MembershipService } from '@app/core/membership.service';

@Injectable()
export class AccountActiveGuardService implements CanActivate {
  constructor(
    private membershipService: MembershipService,
    private router: Router,
    private launchDarklyService: LaunchDarklyService,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return combineLatest([
      this.membershipService.getMembership(true),
      this.launchDarklyService.featureFlag$(FeatureFlags.EXPIRED_TO_GUEST_CONVERSION_WEB, false),
    ]).pipe(
      map(([membership, isFeatureFlagEnabled]) => {
        if (membership.isActive) {
          return true;
        } else {
          const redirectPath = isFeatureFlagEnabled ? '/membership/continue-care' : '/membership/settings';
          this.router.navigate([redirectPath], { replaceUrl: true });
          return false;
        }
      }),
    );
  }
}
